function isArray(value) {
    return Array.isArray(value);
}

export { isArray as default };
